module.exports = __webpack_public_path__ + "img/back-arrow.7c4a9239.png";